import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './ShopProfileActions.scss';

import { setAnalyticsMode } from '../../../Actions/UIActions';
import { isAnalyticsMode } from '../../../Helpers/ui_helpers';
import { isShopper } from '../../../Helpers/user_helpers';

import Loader from '../../Loader/Loader';

const ShopProfileActions = props => {
  const { ui, isFetchingAnalytics, user } = props;
  const analyticsOn = isAnalyticsMode(ui);

  return (
    <div className='shop-profile-actions-container'>
      <div className='actions'>
        {!isShopper(user) && (
          <div onClick={() => props.setAnalyticsMode(!analyticsOn)} className={cn('action', { loading: isFetchingAnalytics })}>
            {analyticsOn ? 'Hide Analytics' : 'Show Analytics'}
            {isFetchingAnalytics && <Loader size={48} />}
          </div>
        )}
        {/* <div className='action'>Share</div> */}
      </div>
    </div>
  );
};

ShopProfileActions.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,
  setAnalyticsMode: PropTypes.func.isRequired,

  // From Outside
  setAnalyticsPerUserId: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user, ui } = state;
  return { user, ui };
};
export default connect(mapStateToProps, {
  setAnalyticsMode
})(ShopProfileActions);
